import { z } from 'zod'
import { MASS_CLR_LINE_FILTERS } from './lineState'

/**
 * The run pages' search params: the tab to open on. Read once on arrival, not kept in sync with
 * the tabs, so a link can land on a tab (the inbox's deviation summary opens `deviated`) without
 * every click rewriting the URL. An unknown value falls back to the default tab.
 */
export const massClrRunSearchSchema = z.object({
  bucket: z.enum(MASS_CLR_LINE_FILTERS).optional().catch(undefined),
})
